// tslint:disable max-func-body-length
import * as React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { InfoText, RadioSymbol } from 'ui';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import {
  emptyAddImportSet, hasFieldValueChanged
} from 'app/area/import-sets-administration/list/add-import-set/add-import-set-helper';
import { AddNewImportSetProps, AddNewImportSetField } from './types';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { CodeSinglePicker } from 'app/area/codetable/common';
import { AddImportSetModal } from 'app/area/import-sets-administration/form/constants';
import { endpoints } from 'app/area/import-sets-administration/list/endpoints';
import { ChangeOptionType } from 'app/area/import-sets-administration/list/types';
import { routeConstants } from 'app/routes/route-constants';
import { ImportSetActionType } from 'app/area/import-sets-administration/form/types';
import styles from './add-import-set.scss';

export class AddNewImportSet extends React.PureComponent<AddNewImportSetProps> {

  constructor(props: AddNewImportSetProps) {
    super(props);
  }

  public componentWillUnmount(): void {
    this.props.clearAddImportSet();
  }

  public componentDidUpdate(prevProps: AddNewImportSetProps) {
    this.handleIsDirty(prevProps);
  }

  private handleIsDirty = (prevProps: AddNewImportSetProps) => {
    hasFieldValueChanged(prevProps, this.props) && this.props.updateIsDirty(true);
  };

  private addNewImportSet = () => {
    const {
      list: { addImportSet: { state, form: { copyImportSet: { value = '' } = {} } = {} } = {} } = {}
    } = this.props;

    navigate.to({
      pathname: {
        [ImportSetActionType.add]: routeConstants.importSetAddFor(),
        [ImportSetActionType.codelikecode]: routeConstants.importSetCodeLikeCodeFor(),
        [ImportSetActionType.duplicate]: routeConstants.importSetDuplicateFor(value)
      }[Object.keys(ImportSetActionType)[state]]
    });
  };

  private onClose = () => {
    this.props.onClose();
    this.props.updateIsDirty(false);
  };

  private create = () => {
    this.props.updateByKey(AddNewImportSetField.copyImportSet, undefined);
    this.props.updateState(ChangeOptionType.Create);
  };

  private copy = () => {
    this.props.updateByKey(AddNewImportSetField.copyImportSet, undefined);
    this.props.updateState(ChangeOptionType.Copy);
  };

  private import = () => {
    this.props.updateByKey(AddNewImportSetField.copyImportSet, undefined);
    this.props.updateState(ChangeOptionType.Import);
  };

  private onChange = (values: ComplexValue<number>) => {
    this.props.updateByKey(AddNewImportSetField.copyImportSet, values);
  };

  private onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    this.props.loadOptions(AddNewImportSetField.copyImportSet, endpoints.copyImportSetOptions, loadOptionsParams);
  };

  public render() {
    const { list: {
      addImportSet }, options, translation } = this.props;

    const selectCreate = addImportSet.state === ChangeOptionType.Create;
    const selectCopy = addImportSet.state === ChangeOptionType.Copy;
    const selectImport = addImportSet.state === ChangeOptionType.Import;

    return (<>
      <ModalWrapper
        headerTitle={translation.import_set}
        btnTitle={translation.create}
        btnCancelTitle={translation.cancel}
        onClose={this.onClose}
        onDone={this.addNewImportSet}
        closeOnDone={false}
        isDisabled={emptyAddImportSet(this.props)}>

        {<div className="row">
          <div className="col-12">
            <div className={styles.container}>
              <div className="form-check">
                <input
                  id="create-import-set"
                  type="radio"
                  className="form-check-input visuallyhidden"
                  value={ChangeOptionType.Create}
                  checked={selectCreate}
                  onChange={this.create} />
                <label
                  htmlFor="create-import-set"
                  className="form-check-label">
                  <RadioSymbol />
                  <b>{translation.create_empty_import_set}</b>
                </label>

                <input
                  id="copy-import-set"
                  type="radio"
                  className="form-check-input visuallyhidden"
                  value={ChangeOptionType.Copy}
                  checked={selectCopy}
                  onChange={this.copy} />
                <label
                  htmlFor="copy-import-set"
                  className="form-check-label">
                  <RadioSymbol />
                  <b>{translation.copy_import_set_and_mappings}</b>
                </label>

                {selectCopy
                  ? <div className="row">
                    <CodeSinglePicker
                      id={AddImportSetModal.copyImportSetMappings}
                      className={'mb-1'}
                      size={12}
                      label={undefined}
                      valueItem={addImportSet?.form?.[AddNewImportSetField.copyImportSet]}
                      readOnly={false}
                      options={options?.[AddNewImportSetField.copyImportSet]?.codes as ComplexValue<number>[] || []}
                      fetchingOptions={options?.[AddNewImportSetField.copyImportSet]?.fetching}
                      translation={translation as any}
                      onLoadOptions={this.onLoadOptions}
                      onChange={this.onChange} />
                  </div>
                  : null}
                <div>
                  <input
                    id="import-import-set"
                    type="radio"
                    className="form-check-input visuallyhidden"
                    value={ChangeOptionType.Import}
                    checked={selectImport}
                    onChange={this.import} />
                  <label
                    htmlFor="import-import-set"
                    className="form-check-label">
                    <RadioSymbol />
                    <div>
                      <b>{translation.import_code_like_code}</b>
                      <InfoText visible={true} text={translation.import_code_like_code_info} />
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>}
      </ModalWrapper>
    </>);
  }
}
